import { NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export class CustomDateAdapter extends MomentDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}

export class CustomNgxDateAdapter extends NgxMatMomentAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}
